<section>
    <img src="assets/images/empty_content_data_light.svg" [alt]="'empty_content_list.image_alt' | translate"
        srcset="assets/images/empty_content_data_light.svg">

    <div>
        <h3>{{ 'empty_content_list.title' | translate }}</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
            magna
            aliqua. Ut enim ad minim veniam</p>
    </div>

    <button class="create-btn cta-primary" (click)="router.navigate(['content-creation'])">
        <kin-icon name="add_circle" />
        <span class="label">
            {{ 'side_menu.create' | translate | upperFirstLetter}}
        </span>
    </button>
</section>